<template>
    <div>
        <div class="manager-panel">
            <a-row type="flex" justify="space-between" align="middle" style="flex-wrap: nowrap">
                <a-button
                        :disabled="!userActiveBudget"
                        type="primary"
                        icon="form"
                        style="margin-right: 15px"
                        @click="createBudget"
                />
                <a-button
                        type="primary"
                        icon="file-excel"
                        style="margin-right: 15px"
                        @click="getRaportBudget"
                />
                <a-dropdown :trigger="['click']" v-model="seachMenuView">
                    <a-input-search
                            class="ant-dropdown-link"
                            placeholder="Search"
                            :value="sortActive"
                    />
                    <a-menu slot="overlay" style="background-color: #fafafa">
                        <a-form
                                id="my_form_search_styl"
                                layout="vertical"
                                style="padding: 15px"
                        >
                            <a-menu-item key="1">
                                <a-form-item
                                        label="Budżet"
                                        :label-col="{ span: 8 }"
                                        :wrapper-col="{ span: 8 }"
                                >
                                    <a-select
                                            v-model="filter.idBudget"
                                            style="width: 170px"
                                            show-search
                                            placeholder="Select"
                                            allowClear
                                            @change="filterUpdate()"
                                            :filter-option="filterOption"
                                    >
                                        <a-select-option
                                                v-for="budget in budgetSelecter"
                                                :value="budget.id"
                                                :key="budget.id"
                                        >{{ budget.nameBudget }}</a-select-option
                                        >
                                    </a-select>
                                </a-form-item>
                            </a-menu-item>
                            <a-menu-item key="2">
                                <a-form-item
                                        label="Deal"
                                        :label-col="{ span: 8 }"
                                        :wrapper-col="{ span: 8 }"
                                >
                                    <a-input style="width: 170px" :value="findDeal(filter.idDeal)" @click="changeDealFilter()"></a-input>
                                </a-form-item>
                            </a-menu-item>
                          <a-menu-item key="3">
                            <a-form-item
                                label="Categories"
                                :label-col="{ span: 8 }"
                                :wrapper-col="{ span: 8 }"
                            >
                              <a-select
                                  @change="filterUpdate()"
                                  v-model="filter.categories"
                                  mode="multiple"
                                  style="width: 170px"
                                  showSearch
                                  allowClear
                                  optionFilterProp="children"
                                  v-decorator="[
            'Categories',
            { rules: [{ required: false }], initialValue: [] },
          ]"
                                  :placeholder="$t('Categories')"
                              >
                                <a-select-option
                                    v-for="(item, id) in categories"
                                    :key="id"
                                    :value="item.ID"
                                >{{ item.NAME }}</a-select-option>
                              </a-select>
                            </a-form-item>
                          </a-menu-item>
                          <a-menu-item key="4">
                            <a-form-item
                                style="text-align: center"
                                :label-col="{ span: 0 }"
                                :wrapper-col="{ span: 24 }"
                            >
                              <a-button type="primary" @click="updateBudget">{{
                                  $t("Search")
                                }}</a-button>
                              <a-button
                                  @click="handleReset()"
                                  style="margin-left: 50px"
                              >{{ $t("Reset") }}</a-button>
                            </a-form-item>
                        </a-form>
                    </a-menu>
                </a-dropdown>
            </a-row>
        </div>
        <a-table :columns="columnsBudgetTable" :data-source="budgetTable" :row-selection="rowSelection">
            <template slot="nameBudget" slot-scope="text">
                <div>
                    {{text}}
                </div>
            </template>
            <template slot="deal" slot-scope="text, record">
                <div>
                    <div v-if="record.edit == 1">
                        <a-input style="width: 160px" @change="changeDealItem(record.id)" @click="changeDealItem(record.id)" :value="findDeal(record.deal)"></a-input>
                    </div>
                    <div v-else>
                        <a target="_blank"
                           @click="findDealCompany(text)"
                           :href="'https://' + domain + '/crm/deal/details/' + findDealId(text) + '/' ">
                        {{findDeal(text)}}
                        </a>
                    </div>
                </div>
            </template>
            <template slot="currenty" slot-scope="text">
                <div>
                    <a-tag v-if="findDealCurrenty(text) != ''" color="blue">{{findDealCurrenty(text)}}</a-tag>
                </div>
            </template>
            <template slot="amountNet" slot-scope="text">
                <div>
                  {{ roundValue(text) }}
                </div>
            </template>
            <template slot="amountConnected" slot-scope="text, record">
                <div v-if="text">
                    <a-tag v-if="(record.amountNet - text) >= 0" color="green">
                      {{ roundValue(text) }}
                    </a-tag>
                    <a-tag v-else color="red">
                      {{ roundValue(text) }}
                    </a-tag>
                </div>
            </template>
            <template slot="edit" slot-scope="innerData, record">
                <div class="editable-row-operations">
                    <span
                            v-if="record.edit == 1"
                            style="display: flex; flex-direction: row">
                        <a
                                :disabled="(record.deal == null) || !userActiveBudget"
                                @click="() => {pushBudget(record)}"
                                style="width: 20px; margin-right: 10px">
                            <a-icon type="save" />
                        </a>
<!--                        <a-popconfirm-->
<!--                                title="Sure to cancel?"-->
<!--                                @confirm="() => {}"-->
<!--                                style="width: 20px"-->
<!--                        >-->
<!--                            <a>-->
<!--                                <a-icon type="redo" />-->
<!--                            </a>-->
<!--                        </a-popconfirm>-->
                    </span>
                    <span v-else>
                        <a
                                v-if="userActiveBudget"
                                @click="() => {removeBudgetClick(record)}"
                        >
                            <a-icon style="color: rgb(255, 77, 79)" type="delete" />

                        </a>
                        <a v-else>
                            <a-icon style="color: #c0c0c0" type="delete" />

                        </a>
                    </span>
                </div>
            </template>
            <positionTable slot="expandedRowRender"
                           slot-scope="innerData"
                           v-model="innerData.positions"
                           :data="innerData"
                           :company="findDealCompany(innerData.deal)"
                           :index="innerData.id"
                           :settings="settings"
                           :pagination="false"
                           :userActiveBudget="userActiveBudget"
                           @updateBudget="downloadBudget"
            />
        </a-table>
    </div>
</template>

<script>
    import { mapMutations, mapGetters, mapActions } from "vuex";
    import {
        addBudget,
        testBudget,
        getBudget,
        raportBudget,
        removeBudget,
        getCategories } from "@/requestFunc";
    import { round10 } from "@/plugins"
    import positionTable from "./budget/positionTable";
    export default {
        name: "budgetTab",
        components: {
            positionTable
        },
        data() {
            return {
                seachMenuView: false,
                columnsBudgetTable: [
                    {
                        title: this.$t("Name"),
                        dataIndex: "nameBudget",
                        scopedSlots: {customRender: "nameBudget"},
                        width: 150,
                    },
                    {
                        title: this.$t("Deal"),
                        dataIndex: "deal",
                        scopedSlots: {customRender: "deal"},
                        width: 150,
                    },
                    {
                        title: this.$t("Waluta"),
                        dataIndex: "deal",
                        scopedSlots: {customRender: "currenty"},
                        width: 80,
                    },
                    {
                        title: this.$t("Kwota netto"),
                        dataIndex: "amountNet",
                        scopedSlots: {customRender: "amountNet"},
                        width: 80,
                    },
                    {
                        title: this.$t("Kwota podpięta"),
                        dataIndex: "amountConnected",
                        scopedSlots: {customRender: "amountConnected"},
                        width: 80,
                    },
                    {
                        title: "",
                        dataIndex: "edit",
                        scopedSlots: {customRender: "edit"},
                        width: 30,
                    }
                ],
                budgetTable: [],
                sortActive: '',
                dealDeleteSelect: [],
                domain: '',
                rowSelection: {},
                activeRaportBudget: [],
                budgetSelecter: [],
                filter: {
                  idBudget: null,
                  idDeal: null,
                  categories: []
                },
                categories: []
            }
        },
        props: [
            'settings',
            'USER_ACTIVE',
            'DEAL_LIST'
        ],
        computed: {
            ...mapGetters(['FILTER_BUDGET']),
            deals: function () {
                return this.settings?.deal ? this.settings?.deal : []
            },
            dealFind: function () {
                let result = {}
                if (this.settings?.deal) {
                    for (let i in this.settings.deal) {
                        result[this.settings.deal[i].ID] = this.settings.deal[i];
                    }
                }
                return result
            },
            userActiveBudget: function () {
                let activeListUser = this.settings.option_get.mediaResponsible ? this.settings.option_get.mediaResponsible : [];


                return activeListUser.find(el => (el == this.USER_ACTIVE.ID)) ? true: false;
            }
        },
        methods: {
            ...mapMutations(['UPDATE_FILTER_BUDGET']),
            ...mapActions(['getReports']),
            test() {
                testBudget()
            },
            roundValue(value) {
              return round10(Number(value), -2);
            },

            createBudget() {
                this.budgetTable.unshift({
                    key: -1,
                    id: 'temp',
                    nameBudget: '',
                    amountNet: 0,
                    amountConnected: 0,
                    deal: null,
                    edit: 1,
                    positions: -1
                })
            },
            pushBudget(record) {
                record.edit = 0;
                addBudget(record.deal).done(() => {
                    this.$message.info(this.$t("Download complete!"));
                    this.downloadBudget();
                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });
            },
            filterOptionDeals(input, option) {
                return (
                    option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                );
            },

            handleChangeDeal(value, id) {

                let newData = [...this.budgetTable];
                let target = newData.filter((item) => id === item.id)[0];
                if (target) {
                    target.deal = value;
                    this.budgetTable = newData;
                }
            },
            createSelectorDeal() {
                for (let i in this.budgetTable) {
                    this.dealDeleteSelect[this.budgetTable[i].deal] = true;
                }
            },
            downloadBudgetSelector() {
                let budget;
                getBudget().done((data) => {
                    let item = data == "" ? {} : JSON.parse(data);
                    if (Array.isArray(item)) {
                        budget = item;
                        let budgetSelecter = budget.map( (el, key) => {
                            return {
                                key,
                                id: el.ID,
                                nameBudget: el.PROPERTY_VALUES.nameBudget,
                            }
                        })
                        this.budgetSelecter = budgetSelecter;
                    }
                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });
            },
            downloadBudget() {
                let budget;
                getBudget(this.FILTER_BUDGET).done((data) => {
                    this.$message.info(this.$t("Download complete!"));
                    let item = data == "" ? {} : JSON.parse(data);
                    if (Array.isArray(item)) {
                        budget = item;
                        let resultBudget = budget.map( (el, key) => {
                            return {
                                key,
                                id: el.ID,
                                nameBudget: el.PROPERTY_VALUES.nameBudget,
                                deal: el.PROPERTY_VALUES.deal,
                                amountNet: el.PROPERTY_VALUES.amountNet,
                                amountConnected: el.PROPERTY_VALUES.amountConnected,
                                positions: 0
                            }
                        })
                        this.budgetTable = resultBudget;
                        this.createSelectorDeal();
                    }
                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });
            },
            findDeal(id) {
                let result = '';
                if (id || id != null) {
                    if (this.dealFind[id]) {
                        result = this.dealFind[id].TITLE;
                    }
                }
                return result;
            },
            findDealId(id) {
                let result = ''
                if (id) {
                    result = this.dealFind[id].ID;
                }
                return result;
            },
            findDealCurrenty(id) {
                let result = ''
                if (id) {
                    result = this.dealFind[id].CURRENCY_ID ? this.dealFind[id].CURRENCY_ID : '';
                }
                return result;
            },
            findDealCompany(id) {
                let result = null;
                if (id) {
                    result = this.dealFind[id].UF_CRM_1550063934 ? this.dealFind[id].UF_CRM_1550063934 : null;
                }
                return result;
            },
            getRaportBudget() {
                let reportButton = undefined;
                if (this.activeRaportBudget.length > 0) {
                    reportButton = this.activeRaportBudget.map(el => (el.id))
                }
                raportBudget(reportButton).done((data) => {
                    this.$message.info(this.$t("Download complete!"));
                    let item = data == "" ? {} : JSON.parse(data);
                    let a = document.createElement('a');
                    a.target="_blank";
                    a.href=item.link;
                    a.click();
                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                );
            },
            updateBudget() {
                this.downloadBudget();
            },
            filterUpdate() {
                this.UPDATE_FILTER_BUDGET(this.filter);
            },
            removeBudgetClick(record) {
                removeBudget(record.id).done((data) => {
                    let item = data == "" ? {} : JSON.parse(data);
                    if (item == "OK") {
                        this.$message.info(this.$t("Remove complete!"));
                        this.downloadBudget();
                    }
                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });
            },

            changeDealFilter() {
                BX24.selectCRM({
                    entityType: ['deal'],
                    multiple: false
                }, (info) => {
                    this.filter.idDeal = parseInt(info.deal[0].id.replace(/[^\d]/g, ''));
                    let filter = {...this.filter};
                    this.UPDATE_FILTER_BUDGET(filter);
                    this.filter = filter;
                    return true;
                })
            },

            changeDealItem(id) {
                BX24.selectCRM({
                    entityType: ['deal'],
                    multiple: false
                }, (info) => {
                    let deal = parseInt(info.deal[0].id.replace(/[^\d]/g, ''));

                    let newData = [...this.budgetTable];
                    let target = newData.filter((item) => id === item.id)[0];
                    if (this.dealDeleteSelect[deal]) {
                        this.$message.info(this.$t("Budżet już istnieje!"));
                    } else {
                        if (target) {
                            target.deal = deal;
                            this.budgetTable = newData;
                        }
                    }

                    return true;
                })
            },
            handleReset() {
              this.filter = {
                idBudget: null,
                idDeal: null,
                categories: []
              }
              this.filterUpdate();
            }
        },
        async mounted() {
          // await this.getReports(this.DEAL_LIST);
          await getCategories().done((data) => {
            let item = data == "" ? {} : JSON.parse(data);
            if (Array.isArray(item.category)) {
              this.categories = item.category;
            }
          })
              .fail((e) => {
                console.err(e);
                this.$message.error(this.$t("Error loading document"));
              });
          this.domain = BX24.getDomain();
          this.downloadBudgetSelector();
          this.downloadBudget();
          this.filter = {...this.FILTER_BUDGET};
          this.rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
              this.activeRaportBudget = selectedRows;
            },
            onSelect: (record, selected, selectedRows) => {
              this.activeRaportBudget = selectedRows;
            },
            onSelectAll: (selected, selectedRows) => {
              this.activeRaportBudget = selectedRows;
            }
          }
        }
    }
</script>

<style scoped>
    .manager-panel {
        margin-bottom: 10px;
    }
</style>
